
import { getKeyFromUrl } from './util/url';
import { PageStatAction } from './common/constants';

/**
 * 常规统计上报
 * @param {*} param0 
 */
export function reportUrl({ statUrl = '', action = '', subkey = '', qbst = '', stsource = '', sturl = '', qt = '' }) {
  const url = `${statUrl}&action=${action}&subkey=${subkey}&qbst=${qbst || getKeyFromUrl('st')}&stsource=${stsource || getKeyFromUrl('stsource')}&sturl=${encodeURIComponent(sturl || getKeyFromUrl('sturl'))}&qt=${qt}&r=${Date.now()}`;
  new Image().src = url;
}

/**
 * 初始化页面行为收集
 *  1. 滚动屏幕，半屏统计
 *  2. 页面停留时长
 */
export function initPageCollect(options) {
  reportPageStayDuration(options);
  reportPageScroll(options);
}

/**
 * 10s间隔区分subkey统计
 * @param {*} options 
 */
function reportPageStayDuration(options) {
  const { statUrl } = options;
  const time = Date.now();

  window.onbeforeunload = function (e) {
    const stayTime = Date.now() - time;
    const timeRate = Math.ceil(stayTime / 1000 / 10) * 10;
    const subkey = `stay_duration_${timeRate}`;
    reportUrl({
      statUrl,
      action: PageStatAction.STAY_DURATION,
      subkey,
      qt: stayTime,
    });
  }
}

/**
 * 半屏幕统计
 * @param {*} options 
 */
function reportPageScroll(options) {
  const { statUrl } = options;

  const pageStatMap = {};
  const deviceHeight = window.self.innerHeight;
  const halfDeviceHeight = parseInt(deviceHeight / 2, 10);

  window.addEventListener('scroll', () => {
    const doubleScrollRate = Math.ceil(window.scrollY / halfDeviceHeight);
    const scrollRate = (doubleScrollRate / 2).toFixed(1);
    const subkey = `scroll_screen_${scrollRate}`;
    const isReported = pageStatMap[subkey] !== undefined;
    if (scrollRate > 0 && !isReported) {
      pageStatMap[subkey] = true;
      reportUrl({
        statUrl,
        action: PageStatAction.SCROLL_SCREEN,
        subkey,
      });
    }
  });
}
